module.exports = __webpack_public_path__ + "img/botella_black_3.8734accf.jpeg";